type AssertPositiveNumber<N extends number> = number extends N ? N : `${N}` extends `-${string}` ? never : N;

type TIME_UNIT = 'seconds' | 'minutes' | 'hours';
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;

export const setTime = <N extends number>(timeDuration: AssertPositiveNumber<N>, timeUnit: TIME_UNIT): number => {
	const timeSet = {
		seconds: timeDuration * SECOND,
		minutes: timeDuration * MINUTE,
		hours: timeDuration * HOUR,
	};

	return timeSet[timeUnit];
};
